import folderStore from 'owa-folders';
import updateFolderCounts from 'owa-mail-actions/lib/updateFolderCounts';
import { mutator } from 'satcheljs';
export default mutator(updateFolderCounts, function (actionMessage) {
    var folderTable = folderStore.folderTable;
    var folder = folderTable.get(actionMessage.folderId);
    if (folder) {
        if (actionMessage.isDeltaChange) {
            folder.UnreadCount += actionMessage.unreadCount;
            folder.TotalCount += actionMessage.totalCount;
        }
        else {
            folder.UnreadCount = actionMessage.unreadCount;
            folder.TotalCount = actionMessage.totalCount;
        }
        // Do not let counts fall below 0 in the store. This state could happen due to the timing of when
        // folder tree is loaded versus listview.
        folder.UnreadCount = Math.max(folder.UnreadCount, 0);
        folder.TotalCount = Math.max(folder.TotalCount, 0);
    }
});
//# sourceMappingURL=updateFolderCountsMutator.js.map